import React from "react";

export type SitProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 34,
    height: 34,
  },
  medium: {
    width: 34,
    height: 34,
  },
  large: {
    width: 34,
    height: 34,
  },
};

export const Sit: JSX.Element & any = React.forwardRef<SVGSVGElement, SitProps>(
  (props, ref) => {
    const { size = "medium", width, height, color = "#AE59C6" } = props;
    const svgSize = width && height ? { width, height } : sizes[size];
    return (
      <svg
        ref={ref}
        width={svgSize.width}
        height={svgSize.height}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.87313 0.580715C7.0238 0.473095 7.2262 0.473095 7.37687 0.580715L11.8917 3.80557L12.7583 4.42462L13.4435 4.91405C13.5574 4.99539 13.625 5.12672 13.625 5.26667V13.0667C13.625 13.306 13.431 13.5 13.1917 13.5L10.1583 13.5V12.0563C10.1583 10.9387 9.29405 10.0331 8.22803 10.0331H6.02197C4.95595 10.0331 4.09167 10.9387 4.09167 12.0563V13.5L2.35833 13.5H1.05833C0.81901 13.5 0.625 13.306 0.625 13.0667V5.26667C0.625 5.12672 0.692585 4.99539 0.806463 4.91405L6.87313 0.580715ZM5.1947 6.85566C5.1947 5.7385 6.05901 4.83333 7.125 4.83333C8.19099 4.83333 9.0553 5.7385 9.0553 6.85566C9.0553 7.97281 8.19099 8.87798 7.125 8.87798C6.05901 8.87798 5.1947 7.97281 5.1947 6.85566Z"
          fill={color}
        />
      </svg>
    );
  }
);

Sit.displayName = "Sit";
